import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTranslate: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTranslate"><Path d="M3.5 5.5L12.5 5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8 5.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 14.5C7.6822 13.3846 5.20506 10.6434 4.5 5.75" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5C8.31602 13.3842 10.7934 10.6429 11.5 5.75" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 19.5L16.75 10.5H17.25L21.4999 19.5M14 17.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTranslate;
